import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

type Role = 'CLIENT' | 'PILOT';

type Props = {
  role: Role;
};

// Sends the user back to onboarding until the backend says onboarding_status === COMPLETED.
// The backend remains the source of truth; this gate just reads the profile already loaded by /auth/me.
export const OnboardingGate = ({ role }: Props) => {
  const { isLoading, clientProfile, pilotProfile } = useAuth();
  if (isLoading) return <div className="p-8">Loading...</div>;
  if (role === 'CLIENT') {
    if (!clientProfile) return <Navigate to="/client/onboarding" replace />;
    if (clientProfile.onboarding_status !== 'COMPLETED') return <Navigate to="/client/onboarding" replace />;
  } else {
    if (!pilotProfile) return <Navigate to="/pilot/onboarding" replace />;
    if (pilotProfile.onboarding_status !== 'COMPLETED') return <Navigate to="/pilot/onboarding" replace />;
  }
  return <Outlet />;
};
